export default defineNuxtRouteMiddleware(async () => {
  const client = useClient()
  const localePath = useLocalePath()

  if (!client.value?.profile_completed) {
    return navigateTo(localePath('/complete'), { replace: true })
  }
})
